/**
 * 2020.6.4
 * handan
 * 统计用户的使用时间
 */

import WebStorageCache from "web-storage-cache";
import moment from "moment";
import API from "../API";
import handleAjaxLimit from "../utils/handleAjaxLimit";

const wsCache = new WebStorageCache()

/*
useTime: {
  2020/06/10: {
    isStart: true,  // 计时开关
    sumDate: "",    // 系统统计总时长
    startTime: "",  // 系统单次开始时间
    endTime: "",
    city,           // 城市信息
    timeDetail:[
      {
        host: "employer.58.com",
        path: "/index",
        title: "恒星首页",
        isStart: true,
        sumDate: "",
        startTime: "",
        endTime: "",
      },
    ]
  }
}
*/

 // 只存储在localstorage，第二天登录时候上报前一天的使用时间
function useTime(system_key, city){
  // 当前系统使用时间 只是计一个开始时间和一个结束时间，设置一个开关，不重复计时

  /*
  onload：
  检查当天是否存储过
    检查是否已经计时
  检查当前页面是否存储过
    检查当前页面是否已经计时
  */

  let dayStr = moment().format("YYYY-MM-DD") ;
  let pathname = window.location.pathname ;
  let host = window.location.host ;
  
  window.onload = function(){
    // 缓存功能
    let useTimeObj = wsCache.get(`useTime_${system_key}`) || {};
    let nowTime = new Date().getTime() ;
    let newPage = true ; //是否是新页面

    if(useTimeObj.hasOwnProperty(dayStr)){
      let item = useTimeObj[dayStr] || {} ;
      let timeDetail = item.timeDetail || [] ;

      if(item.isStart === false){
        // 系统当前没有计时
        item.isStart = true ;
        item.startTime = nowTime ;
      }
      timeDetail.forEach(ele => {
        if(ele.path === pathname){
          newPage = false ;
          if(ele.isStart === false){
            // 页面当前是否计时
            ele.isStart = true ;
            ele.startTime = nowTime ;
          }
        }
      });
      if(newPage){
        // 新页面
        timeDetail.push({
          host,
          path: pathname,
          title: document.title ,
          sumDate: 0,
          startTime: nowTime,
          isStart: true,
        })
      }
      
    }else{
      // 新的一天
      useTimeObj[dayStr] = {
        isStart: true,
        sumDate: 0,
        startTime: nowTime,
        city, 
        timeDetail: [{
          host,
          path: pathname,
          title: this.document.title,
          sumDate: 0,
          startTime: nowTime,
          isStart: true,
        }]
      }
    }
    wsCache.set(`useTime_${system_key}`, useTimeObj) ;

    // 数据上报
    // useTimeAjax(useTimeObj)
  }

  // 页面结束访问时间统计
  if("onpagehide" in window){
    window.onpagehide = function(){
      leavePage() ;
    }
  }else{
    window.onbeforeunload = function(){
      leavePage() ;
    }
  }

  function leavePage(){
    let useTimeObj = wsCache.get(`useTime_${system_key}`) || {};
    let nowTime = new Date().getTime() ;
    if(useTimeObj.hasOwnProperty(dayStr)){
      let item = useTimeObj[dayStr] || {} ;
      if(item.isStart){
        item.isStart = false ;
        let cha = (nowTime - item.startTime) * 1 ;
        if(cha > 0 && item.startTime){
          item.sumDate += cha ;
          item.startTime = false ;
        }
      }
      let timeDetail = item.timeDetail || [] ;
      timeDetail.forEach((ele) => {
        if(ele.path === pathname && ele.isStart){
          ele.isStart = false ;
          let cha = (nowTime - ele.startTime) * 1 ;
          if(cha > 0 && ele.startTime){
            ele.sumDate += cha ;
            ele.startTime = false ;
          }
        }
      })
      wsCache.set(`useTime_${system_key}`, useTimeObj) ;
      
    }
  }
}

// 数据上报
function useTimeAjax(system_key){
  let flag = handleAjaxLimit(1);
  if(!flag) return null;
  // 上报功能 如果没有结束计时，则计时不算数
  let useTimeObj = wsCache.get(`useTime_${system_key}`) || {};
  let keys = Object.keys(useTimeObj) ;
  let dayStr = moment().format("YYYY-MM-DD") ;
  if(keys.length > 1 || (keys.length === 1 && keys[0] !== dayStr)){
    let useTime = {}
    for (const key in useTimeObj) {
      if (useTimeObj.hasOwnProperty(key)) {
        const item = useTimeObj[key];
        if(key !== dayStr){
          useTime[key] = item ;
        }
      }
    }
    let params = {
      system_key,
      useTime,
    }
    //api请求
    API.setUserTime(params)
    .then((res) => {
      let obj = {} ;
      obj[dayStr] = useTimeObj[dayStr] ;
      wsCache.set(`useTime_${system_key}`, obj) ;
      return Promise.resolve(res)
    })
    .catch((err) => {
      // 上报失败
      return Promise.resolve(err)
    })
  }
}

export {
  useTime,
  useTimeAjax,
} ;